import { NavLink } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useConfig } from '../../context/ConfigContext'

const TABS = [
  {
    to: '/',
    label: 'Cobrar',
    roles: ['admin', 'ventas'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6" aria-hidden="true">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <path d="M2 10h20" />
      </svg>
    ),
  },
  {
    to: '/mis-ventas',
    label: 'Mis Ventas',
    roles: ['admin'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6" aria-hidden="true">
        <path d="M18 20V10M12 20V4M6 20v-6" />
      </svg>
    ),
  },
  {
    to: '/mis-productos',
    label: 'Mis Productos',
    roles: ['admin'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6" aria-hidden="true">
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
        <rect x="9" y="3" width="6" height="4" rx="1" />
        <path d="M9 12h6M9 16h4" />
      </svg>
    ),
  },
  {
    to: '/pagos',
    label: 'Pagos',
    roles: ['admin', 'ventas'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    to: '/config',
    label: 'Config',
    roles: ['admin'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6" aria-hidden="true">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
]

export default function BottomNav({ cantidadCarrito }) {
  const { usuario } = useAuth()
  const { config } = useConfig()
  const rol = usuario?.rol ?? 'ventas'
  const tabs = TABS.filter(t =>
    t.roles.includes(rol) &&
    (t.to !== '/pagos' || config.fiadoHabilitado)
  )

  // Admin tiene 5 tabs, ventas tiene 2.
  const scrollable = tabs.length > 4

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-tienda-surface border-t border-tienda-border z-40 safe-area-pb">
      <div className="relative max-w-lg mx-auto">
        <div
          className={`flex ${scrollable ? 'overflow-x-auto' : ''}`}
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {tabs.map(tab => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.to === '/'}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 gap-0.5 transition-colors flex-shrink-0
                ${scrollable ? 'w-[20vw] max-w-[90px]' : 'flex-1'}
                ${isActive ? 'text-tienda-accent' : 'text-tienda-muted'}`
              }
            >
              <div className="relative">
                {tab.icon}
                {tab.to === '/' && cantidadCarrito > 0 && (
                  <span className="absolute -top-1 -right-2 bg-tienda-accent text-gray-900 text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center">
                    {cantidadCarrito > 9 ? '9+' : cantidadCarrito}
                  </span>
                )}
              </div>
              <span className="text-[10px] font-semibold leading-tight text-center">{tab.label}</span>
            </NavLink>
          ))}
        </div>

        {scrollable && (
          <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-tienda-surface to-transparent pointer-events-none" />
        )}
      </div>
    </nav>
  )
}
